/* eslint-disable class-methods-use-this */
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameLayout} from '../../../shared/scripts/ui_game/UIGameLayout'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'

export class UIMGameLayout extends UIGameLayout {
    getHelpSectionY(): number {
        return 0
    }

    getHelpSectionHeight(): number {
        return UIMDeviceHandler.getStatusBarHeight() + this.canvas.appH / 15
    }

    getStateControllerHeight(): number {
        return UIUtilsEjsVariables.isUserOnTabletApp ? this.canvas.itemSize * 0.5 : this.canvas.itemSize * 0.65
    }

    getStateControllerY(): number {
        return this.getHelpSectionY() + this.getHelpSectionHeight()
    }

    getPlayersControllerHeight(): number {
        return UIUtilsEjsVariables.isUserOnTabletApp ? this.canvas.appH - 5 * this.canvas.itemSize : this.canvas.appW * 0.75
    }

    getPlayersControllerChildOffset(): number {
        return this.canvas.itemSize * 0.1
    }

    getEmbargoControllerY(): number {
        return this.getStateControllerY() + this.getStateControllerHeight() + this.canvas.itemSize * 0.05
    }
}

